<div class="container reservation-page">
  <div class="admin-page-header">
    <h1 class="admin-page-title">{{'reserve.title'|traduccion}}</h1>
    <button
      mat-raised-button
      color="primary"
      class="create-button"
      [disabled]="!appService.clientSelected?.online"
      (click)="openManualReserve()">
      <mat-icon>add</mat-icon>
    </button>
  </div>

  <mat-card>
    <app-filter
      [filters]="fieldFilters"
      [massiveAccions]="massiveAccions"
      [loading]="state === 'loading'"
      btLabel="Buscar"
      (submit)="search()"
      (massiveAction)="onClickMassiveAction($event)"
      (massiveActionChanged)="onChangeMassiveActionSelected($event)">
    </app-filter>
  </mat-card>

  <div class="table-container">
    <ng-container [ngSwitch]="state">
      <div *ngSwitchCase="'idle'" class="placeholder">
        <mat-icon>search</mat-icon>
        <div [innerHTML]="'finance.payment.table.idle'|traduccion"></div>
      </div>

      <div *ngSwitchCase="'loading'" class="placeholder">
        <mat-progress-spinner mode="indeterminate" diameter="28"></mat-progress-spinner>
        <div>{{'reserve.table.loading'|traduccion}}</div>
      </div>

      <ng-container *ngSwitchCase="'loaded'">
        <app-data-table
          class="reservation-desktop-view"
          preset="admin"
          shellClass="table-shell"
          tableClass="reservation-table"
          [dataSource]="dataSource"
          [displayedColumns]="displayedColumns"
          [selectionColumn]="selectionColumnConfig"
          [emptyMessage]="'reserve.table.nodata'|traduccion"
          [showPaginator]="true"
          [length]="totalElements"
          [pageSize]="pageSize"
          [pageIndex]="pageIndex"
          [pageSizeOptions]="[10, 25, 50]"
          [rowClickable]="true"
          [rowClass]="'reservation-row'"
          (rowClick)="openDetailModal($event.row)"
          (selectionToggleAll)="masterToggle()"
          (selectionToggleRow)="selection.toggle($event)"
          (page)="onPageChange($event)">
          <ng-container matColumnDef="lockerId">
            <th mat-header-cell *matHeaderCellDef>{{'reserve.table.header.lockerId'|traduccion}}</th>
            <td mat-cell *matCellDef="let element">
              <div class="locker-cell">
                <strong>#{{ element.lockerId }}</strong>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="reference">
            <th mat-header-cell *matHeaderCellDef>{{'reserve.table.header.reference'|traduccion}}</th>
            <td mat-cell *matCellDef="let element">
              <div class="reference-cell">
                <strong>{{ element.categoryCode }}</strong>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>{{'reserve.table.header.status'|traduccion}}</th>
            <td mat-cell *matCellDef="let element">
              <div class="status-cell">
                <app-data-table-badge
                  [label]="element.status|traduccion"
                  [tone]="getReservationStatusTone(element.status)">
                </app-data-table-badge>
                <span class="status-reason" *ngIf="element.reason">{{ element.reason|traduccion }}</span>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef>{{'reserve.table.header.type'|traduccion}}</th>
            <td mat-cell *matCellDef="let element">
              <app-data-table-badge
                [label]="element.type|traduccion"
                [tone]="getReservationTypeTone(element.type)">
              </app-data-table-badge>
            </td>
          </ng-container>

          <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef>{{'reserve.table.header.date'|traduccion}}</th>
            <td mat-cell *matCellDef="let element">
              <div class="date-cell" [class.today]="isToday(element)">
                <strong>{{ element.startTime | date: appService.FORMAT_DATETIME }}</strong>
                <span>{{ element.endTime | date: appService.FORMAT_DATETIME }}</span>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="notice">
            <th mat-header-cell *matHeaderCellDef>{{'reserve.table.header.notice'|traduccion}}</th>
            <td mat-cell *matCellDef="let element">
              <div class="notice-stack">
                <mat-icon *ngIf="element.sync=='SYNC_OK'" class="notice-icon ok">sync</mat-icon>
                <mat-icon *ngIf="element.sync=='SYNC_KIOSK_DOWN'" class="notice-icon warn">sync_problem</mat-icon>
                <mat-icon *ngIf="element.sync=='SYNC_NEED_UP'" class="notice-icon warn">backup</mat-icon>
                <mat-icon *ngIf="element.sync=='SYNC_NEED_DOWN'" class="notice-icon warn">cloud_download</mat-icon>
                <mat-icon *ngIf="!element.paidUpToDate" class="notice-icon danger">money_off</mat-icon>
              </div>
            </td>
          </ng-container>
        </app-data-table>

        <div class="reservation-mobile-view" *ngIf="visibleReservations; else mobileEmptyState">
          <article
            class="reservation-mobile-card"
            *ngFor="let element of dataSource.data"
            [class.is-selected]="selection.isSelected(element)"
            (click)="openDetailModal(element)">
            <div class="mobile-card-top">
              <mat-checkbox
                class="mobile-select"
                (click)="$event.stopPropagation()"
                (change)="selection.toggle(element)"
                [disabled]="!validationAction(element)"
                [checked]="selection.isSelected(element)">
              </mat-checkbox>

              <div class="mobile-main">
                <div class="mobile-title-row">
                  <strong class="mobile-locker">#{{ element.lockerId }}</strong>
                  <span class="mobile-reference">{{ element.categoryCode }}</span>
                </div>
                <div class="mobile-badges">
                  <app-data-table-badge
                    [label]="element.status|traduccion"
                    [tone]="getReservationStatusTone(element.status)">
                  </app-data-table-badge>
                  <app-data-table-badge
                    [label]="element.type|traduccion"
                    [tone]="getReservationTypeTone(element.type)">
                  </app-data-table-badge>
                </div>
                <span class="status-reason" *ngIf="element.reason">{{ element.reason|traduccion }}</span>
              </div>
            </div>

            <div class="mobile-card-section">
              <span class="mobile-label">{{'reserve.table.header.date'|traduccion}}</span>
              <div class="date-cell" [class.today]="isToday(element)">
                <strong>{{ element.startTime | date: appService.FORMAT_DATETIME }}</strong>
                <span>{{ element.endTime | date: appService.FORMAT_DATETIME }}</span>
              </div>
            </div>

            <div class="mobile-card-section" *ngIf="element.sync || !element.paidUpToDate">
              <span class="mobile-label">{{'reserve.table.header.notice'|traduccion}}</span>
              <div class="notice-stack">
                <mat-icon *ngIf="element.sync=='SYNC_OK'" class="notice-icon ok">sync</mat-icon>
                <mat-icon *ngIf="element.sync=='SYNC_KIOSK_DOWN'" class="notice-icon warn">sync_problem</mat-icon>
                <mat-icon *ngIf="element.sync=='SYNC_NEED_UP'" class="notice-icon warn">backup</mat-icon>
                <mat-icon *ngIf="element.sync=='SYNC_NEED_DOWN'" class="notice-icon warn">cloud_download</mat-icon>
                <mat-icon *ngIf="!element.paidUpToDate" class="notice-icon danger">money_off</mat-icon>
              </div>
            </div>
          </article>

          <mat-paginator
            class="reservation-mobile-paginator"
            [length]="totalElements"
            [pageSize]="pageSize"
            [pageIndex]="pageIndex"
            [pageSizeOptions]="[10, 25, 50]"
            [showFirstLastButtons]="true"
            (page)="onPageChange($event)">
          </mat-paginator>
        </div>

        <ng-template #mobileEmptyState>
          <div class="placeholder mobile-empty-state">
            <mat-icon>inbox</mat-icon>
            <div>{{'reserve.table.nodata'|traduccion}}</div>
          </div>
        </ng-template>
      </ng-container>

      <div *ngSwitchCase="'error'" class="placeholder error">
        <mat-icon>error_outline</mat-icon>
        <div>
          {{'reserve.table.error'|traduccion}}
          <button mat-button color="primary" (click)="search()">{{'reserve.table.retry'|traduccion}}</button>
        </div>
      </div>
    </ng-container>
  </div>
</div>
